// components/ProtectedRoute.js
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  const isLoggedIn = sessionStorage.getItem('isLoggedIn');
  return isLoggedIn ? children : <Navigate to="/login" />;
}
